import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const firstString = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return '';
  return String(arr[0] || '').trim();
};

/**
 * Transforms twitter_account criteria.
 * Minimal output: Name + URL (and optionally profileBannerUrl for display).
 *
 * @param {Object} twitterAccountCriteria - criteria.twitter_account
 * @returns {Object} transformed criteria
 */
export const transformTwitterAccount = (twitterAccountCriteria) => {
  if (!twitterAccountCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Twitter Account was found.',
      data: null,
    };
  }

  const wooRankStatus = twitterAccountCriteria?.status || 'neutral';
  const importance = twitterAccountCriteria?.importance || 0;
  const solvability = twitterAccountCriteria?.solvability || 0;

  const name = String(twitterAccountCriteria?.data?.name || '').trim();
  const url = firstString(twitterAccountCriteria?.data?.urls);
  const profileBannerUrl = String(twitterAccountCriteria?.data?.profileBannerUrl || '').trim();

  const isEmpty = !name && !url;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Twitter Account was found.' : null,
    data: isEmpty ? null : { name, url, profileBannerUrl: profileBannerUrl || null },
  };
};

export default transformTwitterAccount;


